import React, { useEffect } from 'react';

import { Image } from 'antd';

import SortablePlaylistItem from '@components/PlaylistEditor/SortablePlaylistItem';

import { usePlaylistEditor } from './PlaylistEditorContext';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';

const PlaylistGrid = () => {
    const { setNodeRef } = useDroppable({
        id: 'playlist-grid',
        strategy: rectSortingStrategy,
    });

    const { playlistItems, documentsList } = usePlaylistEditor();

    return (
        <SortableContext
            items={playlistItems.map((item) => `sortable-${item.ID}`)}
            strategy={rectSortingStrategy}
            measuring={{
                droppable: {
                    strategy: rectSortingStrategy,
                },
            }}
        >
            <div
                ref={setNodeRef}
                className="playlist-grid"
                style={{
                    position: 'relative',
                    touchAction: 'none',
                }}
            >
                <Image.PreviewGroup>
                    {playlistItems.map((playlistItem) => (
                        <SortablePlaylistItem key={playlistItem.ID} playlistItem={playlistItem} />
                    ))}
                </Image.PreviewGroup>
            </div>
        </SortableContext>
    );
};

export default PlaylistGrid;
